/**
 * Use Case: Atualizar Tarefa
 * Orquestra a atualização de uma tarefa existente
 */

import { ITaskRepository } from '../../../domain/repositories/ITaskRepository';
import { NotFoundError } from '../../../core/errors/DomainErrors';

export interface UpdateTaskDTO {
    id: string;
    title?: string;
    dueDate?: Date;
    isCompleted?: boolean;
    description?: string;
}

export class UpdateTaskUseCase {
    constructor(private readonly taskRepository: ITaskRepository) { }

    async execute(dto: UpdateTaskDTO): Promise<void> {
        // Busca tarefa existente
        const task = await this.taskRepository.findById(dto.id);

        if (!task) {
            throw new NotFoundError('Tarefa', dto.id);
        }

        // Atualiza campos
        if (dto.title !== undefined) {
            task.updateTitle(dto.title);
        }

        if (dto.dueDate !== undefined) {
            task.updateDueDate(dto.dueDate);
        }

        if (dto.description !== undefined) {
            task.updateDescription(dto.description);
        }

        if (dto.isCompleted !== undefined) {
            if (dto.isCompleted && !task.getIsCompleted()) {
                task.complete();
            } else if (!dto.isCompleted && task.getIsCompleted()) {
                task.uncomplete();
            }
        }

        // Persiste
        await this.taskRepository.save(task);
    }
}
